import React from 'react';
import { Draggable } from '@hello-pangea/dnd';

/**
 * Componente para renderizar um item arrastável
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.id - ID único do item
 * @param {number} props.index - Posição do item na lista
 * @param {React.ReactNode} props.children - Conteúdo do item
 */
const DraggableItem = ({ id, index, children }) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`
            mb-2 rounded-lg border bg-white 
            ${snapshot.isDragging ? 'shadow-lg' : 'shadow-sm'}
            transition-shadow duration-200
            select-none
          `}
          style={{
            ...provided.draggableProps.style,
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
          data-draggable-id={id}
          data-draggable-index={index}
        >
          {children}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableItem; 